export const getPeriodRowCel = (sortedMinistrationsPlan, status) => {
  const periodColumns = {}
  sortedMinistrationsPlan.forEach(({ orderIndex }) => {
    periodColumns[`period${orderIndex}`] = orderIndex
  })
  return { ...periodColumns, status }
}
